import * as Sentry from '@sentry/browser';

import isError from 'lodash/isError';
import isString from 'lodash/isString';

const getError = (obj: any) => {
  if (isError(obj)) {
    return obj;
  }
  if (isString(obj)) {
    return new Error(obj);
  }
  return new Error(JSON.stringify(obj));
};

const report = (error) => {
  Sentry.captureException(error);
  // eslint-disable-next-line no-console
  console.error(error);
};

const reportOrThrow = (error) => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    throw error;
  } else {
    report(error);
  }
};

export const reportErrorOnly = (obj: any): void => {
  const error = getError(obj);
  report(error);
};

export const reportLogOnly = (name: string, obj: any): void => {
  Sentry.captureMessage(`${name}: ${JSON.stringify(obj)}`);
};

const withErrorPayloadScope = (payload: any, callback) => {
  Sentry.withScope((scope) => {
    scope.setTag('uuid', payload.uuid);
    callback(scope);
  });
};

export const reportErrorPayload = (payload: any) => {
  withErrorPayloadScope(payload, () => {
    reportOrThrow(payload.error);
  });
};

const reportError = (obj: any): void => {
  const error = getError(obj);
  reportErrorPayload({
    error,
    uuid: obj.uuid,
  });
};

export default reportError;
